<template>
  <div class="content">
    <!-- 顶部路径提示 -->
    <div class="thehome">{{ $t("header.home") }} &nbsp;/</div>

    <!-- 必填项提示 -->
    <!-- <div class="require">
      (<span style="color: #ed7e64">*</span>)&nbsp;
      {{ $t("header.This_field_is_required") }}
    </div> -->

    <!-- 核销扫码主体 -->
    <div class="qr-verify">
      <h1>扫码核销</h1>

      <!-- 扫码按钮 -->
      <button v-if="!isScanning" @click="startScan">开始扫码</button>

      <!-- 扫码区域 -->
      <div v-if="isScanning" class="scanner-interface">
        <div id="qr-reader" class="scanner-container"></div>
        <button @click="stopScan">关闭摄像头</button>
      </div>

      <!-- 扫描结果 -->
      <!-- readonly -->
      <input
        type="text"
        v-model="userCode"
        placeholder="扫描结果将显示在这里"
      />

      <!-- 操作按钮 -->
      <!-- <button @click="handleQuery" :disabled="!userCode">查询用户信息</button> -->
      <!-- <button @click="handleVerify(userCode)" :disabled="!userCode">
        确认核销
      </button> -->

      <!-- 状态提示 -->
      <div class="result">{{ resultMessage }}</div>
    </div>

    <div class="btn-wrapper">
      <button class="custom-btn" @click="handleExportAll">
        导出参加活动人员表
      </button>
      <button class="custom-btn" @click="handleExportCheckedIn">
        导出参加活动签到人员表
      </button>
      <button class="custom-btn" @click="handleExportUnchecked">
        导出参加活动未签到人员表
      </button>
    </div>

    <!-- 全部数据表格 -->
    <div class="">
      <!-- display: none;  -->
      <div id="pdf-all" style="padding: 20px; margin: 0 auto" class="pdf-fixed">
        <h3 style="display: flex; flex-direction: column">
          <!-- <img
            src="http://shanghai.siggraph.org/wp-content/uploads/2025/02/siggraph-logo-03-1.png"
            alt=""
            style="width:180px;"
          /> -->
          <!-- <el-icon><UserFilled /></el-icon>  -->
          <span style="margin-top: 20px; font-size: 26px">
            SIGGRAPH Day 2025参加人员表
          </span>
        </h3>
        <el-table :data="dataList" border style="width: 100%">
          <el-table-column prop="username" label="姓名" />
          <el-table-column prop="work_unit" label="单位" />
          <el-table-column prop="email" label="邮箱" />
          <el-table-column prop="phone" label="电话" />
          <el-table-column
            label="签到状态"
            :formatter="
              (row, column, cellValue, index) => {
                return row?.verified_at ? '已签到' : '未签到';
              }
            "
          />
        </el-table>
      </div>

      <!-- 签到 -->
      <div
        id="pdf-checked-in"
        style="padding: 20px; margin: 0 auto"
        class="pdf-fixed"
      >
        <h3>
          <span style="margin-top: 20px; font-size: 26px">
            SIGGRAPH Day 2025已签到人员表
          </span>
        </h3>
        <el-table :data="checkedInList" border style="width: 100%">
          <el-table-column prop="username" label="姓名" />
          <el-table-column prop="work_unit" label="单位" />
          <el-table-column prop="email" label="邮箱" />
          <el-table-column prop="phone" label="电话" />
          <el-table-column prop="verified_at" label="签到时间" />
        </el-table>
      </div>

      <!-- 未签到 -->
      <div
        id="pdf-unchecked"
        style="padding: 20px; margin: 0 auto"
        class="pdf-fixed"
      >
        <h3>
          <span style="margin-top: 20px; font-size: 26px">
            SIGGRAPH Day 2025未签到人员表
          </span>
        </h3>
        <el-table :data="uncheckedList" border style="width: 100%">
          <el-table-column prop="username" label="姓名" />
          <el-table-column prop="work_unit" label="单位" />
          <el-table-column prop="email" label="邮箱" />
          <el-table-column prop="phone" label="电话" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onUnmounted, onMounted, computed } from "vue";
import { Html5Qrcode } from "html5-qrcode";
import { nextTick } from "vue";
import { verification_qrcode, application_forms_list } from "@/api/type.js";
import { ElMessage, ElMessageBox } from "element-plus";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import autoTable from "jspdf-autotable";
const userCode = ref("");
const resultMessage = ref("");
const isScanning = ref(false);
let html5QrCode = null;
const checkedInList = ref([]);
const uncheckedList = ref([]);
const dataList = ref([]);
const startScan = async () => {
  isScanning.value = true;

  await nextTick(); // 等待 DOM 更新（确保 #qr-reader 已插入页面）

  html5QrCode = new Html5Qrcode("qr-reader");

  const config = { fps: 10, qrbox: { width: 250, height: 250 } };

  html5QrCode
    .start(
      { facingMode: "environment" },
      config,
      (decodedText) => {
        userCode.value = decodedText;
        resultMessage.value = "扫描成功";
        // handleQuery(); // ✅ 自动查询
        handleVerify(decodedText);
        stopScan();
      },
      (errorMsg) => {
        console.warn("扫描中错误:", errorMsg);
      }
    )
    .catch((err) => {
      console.error("启动扫码失败:", err);
      resultMessage.value = `摄像头启动失败: ${err}`;
      isScanning.value = false;
    });
};
// const checkedInList = computed(() =>
//   dataList.value.filter((item) => item.verified_at)
// );

// const uncheckedList = computed(() =>
//   dataList.value.filter((item) => !item.verified_at)
// );
// 将 JSON 数据转成表格格式
// const formatData = (list) => {
//   list.map((item) => [
//     item.username,
//     item.work_unit,
//     item.phone,
//     item.email,
//     item.verification_code_status,
//     item.verified_at || "",
//   ]);
// };
const handleExportPDF = async (id, fileName) => {
  const el = document.getElementById(id);
  if (!el) return;

  const originalDisplay = el.style.display;
  el.style.display = "block";

  await nextTick(); // 确保 Element Plus 表格渲染完成

  const canvas = await html2canvas(el, {
    scale: 2,
    useCORS: true,
    width: 1176,
  });

  const imgData = canvas.toDataURL("image/jpeg");
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let position = 0;

  if (imgHeight <= pageHeight) {
    pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
  } else {
    const totalPages = Math.ceil(imgHeight / pageHeight);
    for (let i = 0; i < totalPages; i++) {
      const offsetY = -(pageHeight * i);
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        offsetY,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );
      if (i < totalPages - 1) pdf.addPage();
    }
  }

  pdf.save(fileName + ".pdf");
  // 恢复 display
  el.style.display = originalDisplay;
};
const handleExportAll = () => {
  handleExportPDF("pdf-all", "参加活动人员表");
};

const handleExportCheckedIn = () => {
  handleExportPDF("pdf-checked-in", "签到人员表");
};

const handleExportUnchecked = () => {
  handleExportPDF("pdf-unchecked", "未签到人员表");
};
const stopScan = () => {
  if (html5QrCode) {
    html5QrCode.stop().then(() => {
      html5QrCode.clear();
      html5QrCode = null;
    });
  }
  isScanning.value = false;
};

// const handleQuery = () => {

//   resultMessage.value = `正在查询用户: ${userCode.value}`;
//   setTimeout(() => {
//     resultMessage.value = `用户 ${userCode.value} 查询成功，可核销`;
//   }, 1000);
// };

const handleVerify = async (e) => {
  resultMessage.value = `正在核销: ${userCode.value}`;
  try {
    const res = await verification_qrcode({
      verification_code: e,
    });

    const { success, message, data } = res;

    if (!success) {
      // 失败情况：如核销码为空/无效
      ElMessage.error(message);
      resultMessage.value = message;
    } else {
      // 成功情况：核销成功或已被核销
      const infoText = `
  姓名：${data.username}<br/>
  单位：${data.work_unit}<br/>
  电话：${data.phone}<br/>
  邮箱：${data.email}<br/>
  核销时间：${data.verified_at}
    `;

      ElMessageBox.alert(infoText, message, {
        title: "核销信息",
        confirmButtonText: "知道了",
        type: "success",
        customClass: "success-message-box",
        dangerouslyUseHTMLString: true, // ✅ 关键设置
      });

      resultMessage.value = message;

      // 清空二维码数据（可选）
      userCode.value = "";
    }
  } catch (error) {
    console.error("核销失败：", error);
    ElMessage.error("核销请求失败，请稍后重试");
    resultMessage.value = "请求失败";
  }
};
onMounted(() => {
  application_forms_list().then((res) => {
    // console.log(res, 1234);
    dataList.value = res;
    checkedInList.value = res.filter((i) => i.verified_at);
    uncheckedList.value = res.filter((i) => !i.verified_at);
  });
});

// 页面卸载时释放资源
onUnmounted(() => {
  stopScan();
});
</script>

<style scoped lang="scss">
.pdf-fixed {
  width: 1176px;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
  position: fixed;
  top: 0;
  left: -99999px; /* 屏幕之外渲染 */
  z-index: -9999;
}
.content {
  position: relative;
  padding-bottom: 50px;
  .btn-wrapper {
    display: flex;
    flex-wrap: wrap; /* 自动换行 */
    justify-content: center; /* 居中对齐 */
    gap: 20px; /* 按钮之间间距 */
    margin-top: 36px;
  }

  .custom-btn {
    background-color: #4155d9;
    color: white;
    padding: 10px 18px;
    border-radius: 6px;
    min-width: 200px;
    text-align: center;
    font-size: 14px;
    transition: background-color 0.3s;
    border: 0px !important;
    cursor: pointer;
  }

  .custom-btn:hover {
    background-color: #383faa; /* 加深颜色 */
  }
  .thehome {
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    padding: 68px 0 0 0;
    text-align: left;
    margin-bottom: 80px;
  }

  .require {
    text-align: right;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 32px;
  }
}

.qr-verify {
  max-width: 480px;
  margin: 0 auto;
  padding: 24px;
  border: 1px solid #eee;
  border-radius: 12px;
  background: #f9f9f9;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  font-family: "Arial", sans-serif;
  text-align: center;

  h1 {
    font-size: 24px;
    margin-bottom: 16px;
    color: #333;
  }

  button {
    margin: 10px 5px;
    padding: 10px 18px;
    border: none;
    background-color: #3657db;
    color: #fff;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s ease;
  }

  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  button:hover:not(:disabled) {
    background-color: #274bbb;
  }

  input[type="text"] {
    width: 90%;
    padding: 8px 12px;
    font-size: 14px;
    margin-top: 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background-color: #fff;
    color: #333;
  }

  .scanner-interface {
    margin: 1em 0;
    position: relative;
    padding: 16px;
    background: #fff;
    border: 1px dashed #ccc;
    border-radius: 8px;
  }

  .scanner-container {
    width: 100%;
    height: auto;
  }

  .result {
    margin-top: 1em;
    font-weight: bold;
    color: #3657db;
  }
}
@media screen and (max-width: 1200px) {
  .content {
    padding: 30px;
    .thehome {
    }
  }
}
</style>
<style>
/* pdf 样式，确保打印时一致 */
#pdf-all,
#pdf-checked-in,
#pdf-unchecked {
  width: 1176px;
  font-size: 14px;
  background-color: white;
  color: black;
}

.pdf-export h3 {
  display: flex;
  align-items: center;
  font-size: 18px;
  margin-bottom: 10px;
}

.pdf-export h3 .el-icon {
  margin-right: 6px;
}

.el-table {
  font-size: 13px;
}
</style>
